/**
 * Lucide-style microphone (24×24 viewBox, 2px stroke), the outline twin of
 * `EditPenIcon`. PLAT-11662: the two Review entries — pencil for Translation
 * Review, microphone for Dubbing Review — sit side by side in the transcript
 * toolbar and the review header's mode tabs, so they share one weight and
 * size. The filled `MicrophoneIcon` stays the dub-status glyph elsewhere.
 */
export function MicStrokeIcon({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <line x1="12" x2="12" y1="19" y2="22" />
    </svg>
  );
}
